import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { setIsCreateCustomerDialogOpen, setIsSearchByPhoneCustomerDialogOpen } from 'slices/customer/createCustomerSlice'

import NewAccountDrawer from './NewAccountDrawer'
import SearchCustomerByEmail from './SearchCustomerByEmail/SearchCustomerByEmail'
import SearchCustomerByPhone from './SearchCustomerByPhone/SearchCustomerByPhone'

const WithNewCustomerDialog = ({ children }) => {
  const isCreateDialogOpen = useSelector(s => s.createCustomer.isCreateDialogOpen)
  const isSearchByPhoneDialogOpen = useSelector(s => s.createCustomer.isSearchByPhoneDialogOpen)
  const dispatch = useDispatch()
  const searchByPhoneForm = useForm({ defaultValues: { phone: '' }, mode: 'onSubmit' })
  const searchByEmailForm = useForm({ defaultValues: { email: '' }, mode: 'onSubmit' })
  const { watch: watchPhoneForm } = searchByPhoneForm
  const { watch: watchEmailForm } = searchByEmailForm
  const phone = watchPhoneForm('phone')
  const email = watchEmailForm('email')
  const closeSearchDialog = () => {
    dispatch(setIsSearchByPhoneCustomerDialogOpen(false))
  }

  const closeCreateDialog = useCallback(() => {
    dispatch(setIsCreateCustomerDialogOpen(false))
  }, [dispatch])

  return (
    <>
      {children}
      <FormProvider {...searchByPhoneForm}>
        <SearchCustomerByPhone onClose={closeSearchDialog} isOpen={isSearchByPhoneDialogOpen} />
      </FormProvider>
      <FormProvider {...searchByEmailForm}>
        <SearchCustomerByEmail />
      </FormProvider>
      <NewAccountDrawer email={email} isOpen={isCreateDialogOpen} phone={phone} onClose={closeCreateDialog} />
    </>
  )
}

WithNewCustomerDialog.propTypes = {
  children: PropTypes.node,
}

export default WithNewCustomerDialog
